import Cookies from 'js-cookie';
import actions from './actions';

const {
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_ERR,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_ERR,
  UPDATE_PASSWORD_DETAILS_BEGIN,
  UPDATE_PASSWORD_DETAILS,
  UPDATE_PASSWORD_DETAILS_ERR,
  UPDATE_PASSWORD_DETAILS_EMPTY,
} = actions;

const initState = {
  login: Cookies.get('logedIn'),
  loading: false,
  error: null,
};
const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
const UpdatePasswordDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_PASSWORD_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case UPDATE_PASSWORD_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case UPDATE_PASSWORD_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case UPDATE_PASSWORD_DETAILS_EMPTY:
      return {
        ...initialStateFilter,
        loading: true,
      };
    default:
      return state;
  }
};
export { AuthReducer, UpdatePasswordDetailsReducer };
